import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'A size set was deleted',
  name: 'size_set_deleted',
  params: [
    {
      description: 'Where the deletion was made from',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['context'],
    },
    {
      description: 'Number of members in the set at the time it was deleted',
      name: 'member_count',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
